<div class="p-2">
  <div class="w-100 px-3 fs-normal " style="min-height: 600px;">
    <ngx-spinner name="action" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <div class="d-flex justify-content-between align-items-center px-4">
      <button class="btn btn-yellow fs-sm" type="button" (click)="save()">ذخیره</button>
    </div>

    <h1 class="text-center">مهارت‌ اشتباه</h1>
    <div class="form-group">
      <div>فوانین open-refine</div>
      <textarea dir="ltr" name="rules" #rawRules (change)="read(rawRules.value)" placeholder="لیست قوانین" rows="10">
      </textarea>
    </div>

    <section class="container-fluid">
      <div class="row fs-normal sticky  dark-gray-bg f-yellow text-center">
        <div class="col-3 ">مهارت های اشتباه [{{rules?.length}}]</div>
        <div class="col border-left border-right">مشابه‌ها</div>
      </div>

      <ng-container *ngFor="let metadata of rules">
        <div class="row border-bottom light-yellow-bg-hover">
          <div class="col-3 overflow-auto" style="max-height: 100px;">
            <div>"{{metadata.Header}}"</div>
          </div>
          <div class="col border-left border-right">
            <div class="py-1">
              <div class="badge-kp px-1 py-1 light-gray-bg ml-1 mb-1" *ngFor="let item of metadata.Variations">{{item}}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </section>
  </div>
</div>